import { Input, Switch, Form, Select, Divider } from 'antd';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import MyInput from './Input';
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

const { TextArea } = Input;

const CustomerForm = (props) => {
  const { isEdit, customerData, isSaveCustomer, handleClickSave, form, createSearch, isOpen, isTemp, setIsTemp } = props;
  const intl = useIntl();
  // const {} = customerData
  //   const isEdit = true;
  const mockData = 'default data text';
  // const [type, setType] = useState(CORPORATE_TYPE);

  // const isCorporateType = type === CORPORATE_TYPE;

  // const handleChangeType = () => {
  //   const newType = isCorporateType ? INDIVIDUAL_TYPE : CORPORATE_TYPE;
  //   setType(newType);
  // };

  useEffect(() => {
    // //console.log('TestEdit', isEdit, isOpenCustomerModal);
    if (isEdit === true) {
      form.setFieldsValue({
        // name: isEdit? _.get(customerData, 'customerContactName') : '',
        name: _.get(customerData, 'customerContactName'),
        phone: _.get(customerData, 'customerContactPhone'),
        email: _.get(customerData, 'customerContactEmail'),
        remark: _.get(customerData, 'remark'),
      });
    } else {
      form.setFieldsValue({
        name: createSearch ? createSearch : '',
      });
    }
  }, [createSearch, customerData, isOpen, isEdit]);

  const handleOnkeyPressNumber = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <div className='d-flex flex-column py-4 m-2'>
      <Form form={form}>
        <Form.Item
          name='name'
          rules={[
            {
              required: true,
              message: <FormattedMessage id='validateName' defaultMessage='Please Enter Name' />,
            },
          ]}
        >
          <MyInput
            isRequired
            label={<FormattedMessage id='labelName' defaultMessage='Name' />}
            placeHolder={intl.formatMessage({ id: 'placeholderName', defaultMessage: 'Enter Name' })}
            className='w-100'
          />
        </Form.Item>
        <Form.Item
          name='phone'
          rules={[
            {
              required: true,
              message: <FormattedMessage id='validatePhone' defaultMessage='Please Enter Phone' />,
            },
          ]}
        >
          <MyInput
            isRequired
            label={<FormattedMessage id='labelPhone' defaultMessage='Phone Number' />}
            placeHolder={intl.formatMessage({ id: 'placeholderPhone', defaultMessage: 'Enter Phone Number' })}
            className='w-100'
            onKeyPress={handleOnkeyPressNumber}
          />
        </Form.Item>

        <Form.Item name='email'>
          <MyInput
            className='w-100'
            label={<FormattedMessage id='labelEmail' defaultMessage='Email' />}
            placeHolder={intl.formatMessage({ id: 'placeholderEmail', defaultMessage: 'Enter Email' })}
            onkey
          />
        </Form.Item>

        <Typography isBold color={COLORS.Primary} className='pb-2'>
          <FormattedMessage id='labelRemark' defaultMessage='Remark' />
        </Typography>
        <Form.Item name='remark'>
          <TextArea className='pb-3 w-100' placeHolder={intl.formatMessage({ id: 'placeholderRemark', defaultMessage: 'Enter Remark' })} />
        </Form.Item>
        {/* {isSaveCustomer && (
          <div className='pt-4 mt-2 d-flex flex-row justify-content-between align-items-center'>
            <div className='d-flex flex-column'>
              <Typography isBold color={COLORS.Primary} className='pb-2'>
              <FormattedMessage id='labelSaveCustomer' defaultMessage='Save Customer' />
              </Typography>
              <Typography color={COLORS.DarkGray} size='12px'>
              <FormattedMessage id='labelSaveCustomer' defaultMessage='Enable this to save customer' />
              </Typography>
            </div>
            <div>
              <Switch
                defaultChecked
                checked={isTemp}
                onChange={(e) => {
                  setIsTemp(e);
                }}
              />
            </div>
          </div>
        )} */}
      </Form>
    </div>
  );
};

export default CustomerForm;
